import { render, staticRenderFns } from "./solutionDetail.vue?vue&type=template&id=2fdc9d42&scoped=true&"
import script from "./solutionDetail.vue?vue&type=script&lang=js&"
export * from "./solutionDetail.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetail.vue?vue&type=style&index=0&id=2fdc9d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc9d42",
  null
  
)

export default component.exports